import { render, staticRenderFns } from "./NormativeModal.vue?vue&type=template&id=479a9fb6&scoped=true"
import script from "./NormativeModal.vue?vue&type=script&lang=js"
export * from "./NormativeModal.vue?vue&type=script&lang=js"
import style0 from "./NormativeModal.vue?vue&type=style&index=0&id=479a9fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a9fb6",
  null
  
)

export default component.exports